import { render } from "./SuiteHorizonFilter.vue?vue&type=template&id=18d341a3"
import script from "./SuiteHorizonFilter.vue?vue&type=script&lang=js"
export * from "./SuiteHorizonFilter.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__